import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { Operater } from "../../../../screens/OstaliOperateri";

const Index = () => {
  const { register, getValues, setValue, watch } = useFormContext();
  const ostaliOperateri = getValues("ostaliOperateri");
  const odabraniOperater = getValues("odabraniOperater");

  return (
    <FormControl fullWidth>
      <InputLabel id={"odabraniOperater"}>Operater</InputLabel>
      <Select
        labelId={"odabraniOperater"}
        id={"odabraniOperater"}
        value={odabraniOperater}
        label={"odabraniOperater"}
        variant={"standard"}
        {...register("odabraniOperater")}
        onChange={(e: SelectChangeEvent<any>) => {
          setValue("odabraniOperater", e.target.value);
          setValue("noviOperater", null);
        }}
      >
        {ostaliOperateri.map((operater: Operater, key: number) => (
          <MenuItem value={operater.id} key={key}>
            {operater.naziv.naziv}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Index;
